var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form',{ref:"form"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"row col-12 pr-0 mb-3"},[_c('span',[_vm._v("Are you sure you want to delete "),_c('strong',[_vm._v(_vm._s(_vm.name))]),_vm._v("?")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }